import { useEffect, useMemo, useState } from "react";
import { api, type Contact } from "../../lib/api";
import { useToast } from "../shell/Toast";

export function ContactsWorkspace() {
  const toast = useToast();
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [q, setQ] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [cardUrl, setCardUrl] = useState("");
  const [cardUser, setCardUser] = useState("");
  const [cardPass, setCardPass] = useState("");
  const [error, setError] = useState("");

  async function refresh() {
    try {
      const res = await api.contacts();
      setContacts(res.contacts);
      setError("");
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    }
  }

  useEffect(() => {
    void refresh();
  }, []);

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return contacts;
    return contacts.filter(
      (c) =>
        c.displayName.toLowerCase().includes(s) ||
        c.email.toLowerCase().includes(s) ||
        (c.phone || "").includes(s),
    );
  }, [contacts, q]);

  async function save() {
    await api.saveContact({ displayName: name, email, phone, source: "local" });
    setName("");
    setEmail("");
    setPhone("");
    toast.push({ message: "Contact saved" });
    await refresh();
  }

  async function addCardDav() {
    await api.addCardDav({ url: cardUrl, username: cardUser, password: cardPass });
    toast.push({ message: "CardDAV synced" });
    await refresh();
  }

  return (
    <div className="workspace" style={{ gridTemplateColumns: "320px 1fr" }}>
      <aside className="pane folders">
        <div className="pane-head">
          <div>
            <div className="eyebrow">People</div>
            <strong>Contacts</strong>
          </div>
        </div>
        <div style={{ padding: "0.85rem", display: "grid", gap: "0.55rem" }}>
          <input className="input" placeholder="Search" value={q} onChange={(e) => setQ(e.target.value)} />
          <div className="eyebrow">New contact</div>
          <input className="input" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
          <input className="input" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input className="input" placeholder="Phone" value={phone} onChange={(e) => setPhone(e.target.value)} />
          <button className="btn btn-primary" onClick={() => void save()}>
            Save contact
          </button>
          <div className="eyebrow">CardDAV</div>
          <input className="input" placeholder="CardDAV URL" value={cardUrl} onChange={(e) => setCardUrl(e.target.value)} />
          <input className="input" placeholder="Username" value={cardUser} onChange={(e) => setCardUser(e.target.value)} />
          <input
            className="input"
            type="password"
            placeholder="Password"
            value={cardPass}
            onChange={(e) => setCardPass(e.target.value)}
          />
          <button className="btn" onClick={() => void addCardDav()}>
            Sync address book
          </button>
          {error && <div className="error">{error}</div>}
        </div>
      </aside>
      <section className="pane read">
        <div className="people-body">
          <div className="people-list">
            {filtered.map((c) => (
              <div key={c.id} className="person-card">
                <strong>{c.displayName}</strong>
                <div>{c.email}</div>
                {c.phone && <div style={{ color: "var(--muted)" }}>{c.phone}</div>}
                <div className="eyebrow">{c.source}</div>
                <button
                  className="btn btn-danger"
                  onClick={async () => {
                    await api.deleteContact(c.id);
                    await refresh();
                  }}
                >
                  Remove
                </button>
              </div>
            ))}
            {filtered.length === 0 && <div className="empty">No contacts yet</div>}
          </div>
        </div>
      </section>
    </div>
  );
}
